import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';

export const UpgradeLock = ({ title = 'this feature', plan = 'Pro', testid }) => (
  <div className="glass rounded-2xl p-10 text-center" data-testid={testid || 'upgrade-lock'}>
    <div className="inline-flex flex-col items-center gap-4">
      <div className="w-14 h-14 rounded-2xl bg-boosta-yellow/10 flex items-center justify-center">
        <Lock className="w-6 h-6 text-boosta-yellow"/>
      </div>
      <div>
        <div className="font-display font-bold text-2xl text-3d">Upgrade to {plan}</div>
        <div className="text-white/55 text-sm mt-2 max-w-md">{title} is available on the <span className="text-boosta-cyan font-bold">{plan}</span> plan and above.</div>
      </div>
      <Link to="/payments" className="btn-primary rounded-full px-5 py-2.5 text-sm inline-flex items-center gap-2" data-testid="upgrade-lock-cta">
        <Sparkles className="w-4 h-4"/> View plans &amp; upgrade
      </Link>
    </div>
  </div>
);
